import _ from '@lodash';
import WorkflowItem from '../WorkflowItem';

export const defaultDefinition = {
	input_fields: [{ name: 'Components', type: 'Components', enabled: true, value: null }],
	output_fields: [{ name: 'Components', type: 'Components' }],
	feature_column: null,
	component_title: null,
	input_components: [],
	output_component: null
};

export const converter = function (data) {
	return data;
};

export default function MergeComponentsTransformation(props) {
	return <WorkflowItem {...props} type="MERGE_COMPONENTS" />;
}
